package com.essntl.core.waypoint.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SimpleEmailTemplateData(
    val templateId: String?,
    val from: String,
    val to: String,
    val cc: String?,
    val bcc: String?,
    val replyTo: String,
    val variables: SimpleMessageVariables,
)

@Serializable
data class SimpleMessageVariables(
    val message: String,
    val senderName: String,
    val senderPhone: String,
    val senderEmail: String,
) {
    companion object {
        val empty =
            SimpleMessageVariables(
                message = "",
                senderName = "-",
                senderPhone = "-",
                senderEmail = "-",
            )
    }
}

@Serializable
data class POServicesTemplate(
    val templateId: String?,
    val from: String,
    val to: String,
    val cc: String?,
    val bcc: String?,
    val replyTo: String,
    val variables: POServicesVariables,
)

@Serializable
data class POServicesVariables(
    val message: String,
    val senderName: String,
    val senderPhone: String,
    val senderEmail: String,
    val services: List<POServiceData>,
) {
    companion object {
        val empty =
            POServicesVariables(
                message = "",
                senderName = "-",
                senderPhone = "-",
                senderEmail = "-",
                services = emptyList(),
            )
    }
}

@Serializable
data class POServiceData(
    val clientId: String,
    val clientName: String,
    val clientPhone: String,
    val guestCount: String,
    val serviceId: String,
    val category: String,
    val serviceName: String,
    val supplierName: String,
    val date: String,
    val startTime: String,
    val endTime: String,
    val meetingPoint: String,
    val address: String,
    val notes: String,
    val dynamicFields: String,
)
